/**
 * The site's current homepage positioning, sent to Google Analytics as
 * `landing_variant` on every page view and on `sign_up` (#1475), so two
 * positionings compare with one filter instead of deploy-date arithmetic.
 *
 * Bump this in the same PR as any positioning change — name it after what the
 * page says and the day it reaches production.
 */
export const LANDING_VARIANT = "email-2026-10-23";
